import React from 'react';
import Loader from '@pillvery/components/utility/loader';
import {useSelector} from 'react-redux';

export default function ChartCard({label, description, value, chart, cardWidth = 4, footer, className, data, loaderBorderColor = '#29c0b1'}) {
    
    const { statistics, loading } = useSelector(state => state.Dashboard);

    console.debug({label, value});
    return (
        <div className={"col-md-"+cardWidth+" grid-margin stretch-card " + className}>
            <div className="card">
                <div className="card-body">
                    <div className="d-flex align-items-start justify-content-center">
                        <p className="card-title ">{ label }</p>
                        {/*<div className="dropdown dropright card-menu-dropdown">*/}
                        {/*    <button className="btn" type="button" id="cardMenuButton1"*/}
                        {/*            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">*/}
                        {/*        <i className="mdi mdi-dots-horizontal card-menu-btn"></i>*/}
                        {/*    </button>*/}
                        {/*    <div className="dropdown-menu" aria-labelledby="cardMenuButton1">*/}
                        {/*        <a className="dropdown-item" href="#">Action</a>*/}
                        {/*        <a className="dropdown-item" href="#">Another action</a>*/}
                        {/*        <a className="dropdown-item" href="#">Something else here</a>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                    {
                        description ? (
                            <p className="text-muted mb-5">{ description }</p>
                        ):""
                    }
                    
                    {loading && 
                        <Loader color={loaderBorderColor} />
                    }

                    {!loading ? (
                        <>
                            <div
                                className="d-flex flex-column justify-content-center align-items-center">
                                <h2 className="font-weight-bold">{value}</h2>

                                {/* <div className="d-flex align-items-baseline flex-wrap justify-content-center">
                                    <h5 className="mb-0 font-weight-normal text-success">1.35</h5>
                                    <i className="mdi mdi-arrow-up text-success mr-1"></i>
                                    <h5 className="mb-0 mt-0 mt-md-2 mt-xl-0 font-weight-normal">
                                        More than last month
                                    </h5>
                                </div> */}
                            </div>
                        </>
                    ) : null}

                    {value ? "" : chart}
                    {value ? "" : footer}
                </div>
                {value ? chart : ""}
            </div>
        </div>
    )
}